module.exports = __webpack_public_path__ + "img/_1.22b792d3.png";